import { render, staticRenderFns } from "./PeopleDetail.vue?vue&type=template&id=420e45fc&scoped=true&"
import script from "./PeopleDetail.vue?vue&type=script&lang=ts&"
export * from "./PeopleDetail.vue?vue&type=script&lang=ts&"
import style0 from "./PeopleDetail.vue?vue&type=style&index=0&id=420e45fc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420e45fc",
  null
  
)

export default component.exports